// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Password_header__6047R {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 5px;
  border-bottom: 1px solid #bebebe;
  padding-bottom: 10px;
}

.Password_title__hfvPN {
  font-family: BebasNeue;
  font-weight: 700;
  color: var(--darkGray);
  font-size: 20px;
}

.Password_body__Da5ez {
  text-align: center;
  color: var(--darkGray);
  margin: 40px 0;
}

.Password_body__Da5ez p {
  display: block;
  margin-bottom: 30px;
}

.Password_action__sEZ98 {
  display: flex;
  justify-content: center;
}

.Password_submit__tQ\\+LK {
  font-weight: 500;
  font-size: 12px;
  width: 300px;
}

.Password_input__YN9IC,
.Password_input__YN9IC .Password_ant-select-selector__itbUG {
  background-color: #fbfbfb;
  border-color: #d2d2d2;
  border-radius: 4px;
}
`, "",{"version":3,"sources":["webpack://./src/pages/users/styles/Password.module.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,YAAY;AACd;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;AACpB","sourcesContent":[".header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 5px;\n  border-bottom: 1px solid #bebebe;\n  padding-bottom: 10px;\n}\n\n.title {\n  font-family: BebasNeue;\n  font-weight: 700;\n  color: var(--darkGray);\n  font-size: 20px;\n}\n\n.body {\n  text-align: center;\n  color: var(--darkGray);\n  margin: 40px 0;\n}\n\n.body p {\n  display: block;\n  margin-bottom: 30px;\n}\n\n.action {\n  display: flex;\n  justify-content: center;\n}\n\n.submit {\n  font-weight: 500;\n  font-size: 12px;\n  width: 300px;\n}\n\n.input,\n.input .ant-select-selector {\n  background-color: #fbfbfb;\n  border-color: #d2d2d2;\n  border-radius: 4px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Password_header__6047R`,
	"title": `Password_title__hfvPN`,
	"body": `Password_body__Da5ez`,
	"action": `Password_action__sEZ98`,
	"submit": `Password_submit__tQ+LK`,
	"input": `Password_input__YN9IC`,
	"ant-select-selector": `Password_ant-select-selector__itbUG`
};
export default ___CSS_LOADER_EXPORT___;
